import { textStyles } from '../../theme'


export default {
  container: {
    ...textStyles.h1,
    textAlign: 'center',
  },
}
